import './index.css';
import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Seats from './pages/Seats';
import Tickets from './pages/Tickets'; 
import Contact from './pages/Contact';
import { TicketProvider } from './state/TicketContext'; 

function App() {
  return (
    <TicketProvider> 
      <Router>
        <Routes>
          <Route path="/fandango-project" element={<Tickets />} />
          <Route path="/seats" element={<Seats />} /> 
          <Route path="/contact" element={<Contact />} /> 
        </Routes>
      </Router>
    </TicketProvider>
  );
}

export default App;
